'use client';

import { useRouter } from 'next/navigation';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';

export default function NotFound() {
  const { t } = useTranslation();
  const router = useRouter();

  return (
    <div className="flex min-h-screen items-center justify-center bg-atomic-white px-4">
      <div className="w-full max-w-md text-center">
        <div className="mb-6">
          <h1 className="mb-4 font-mona-sans text-semantic-label-strong text-title-1-bold">404</h1>
          <h2 className="mb-2 font-mona-sans text-semantic-label-strong text-title-2-bold">
            {t('Common.notFound.page.title')}
          </h2>
          <p className="font-mona-sans text-body-1-normal-regular text-semantic-label-normal">
            {t('Common.notFound.page.description')}
          </p>
        </div>

        <Button
          variant="cta-solid-alternative"
          onClick={() => router.push('/challenges')}
          data-cy="back-to-challenges"
        >
          {t('Common.notFound.page.button')}
        </Button>
      </div>
    </div>
  );
}
